module.exports = __webpack_public_path__ + "img/educacao2.4689c98b.svg";